module.exports = __webpack_public_path__ + "static/media/RO.583d4688.svg";